import {CsvModel} from "../../util/CSVWriteUtil";
import {MonthlyOfficeVisitReport} from "../../api/VisitWithStatStore";

export function downloadVisitReportCsv(reports: MonthlyOfficeVisitReport[]) {
    const model = new CsvModel<MonthlyOfficeVisitReport>([
        {
            header: 'Month',
            value: row => row.month,
        },
        {
            header: 'Average visits per day',
            value: row => {
                return row.visitStats.avgVisits.value.toString();
            },
        },
        {
            header: 'Average %',
            value: row => {
                return row.visitStats.avgVisits.percent.toFixed() + '%';
            },
        },
        {
            header: 'Median',
            value: row => {
                return row.visitStats.median.value.toString();
            },
        },
        {
            header: 'Median %',
            value: row => {
                return row.visitStats.median.percent.toFixed() + '%';
            },
        },
        {
            header: 'P₉₀',
            value: row => {
                return row.visitStats.percentile90.value.toString();
            },
        },
        {
            header: 'P₉₀ %',
            value: row => {
                return row.visitStats.percentile90.percent.toFixed() + '%';
            },
        },
        {
            header: 'Max',
            value: row => {
                return row.visitStats.maxVisits.value.toString();
            },
        },
        {
            header: 'Max %',
            value: row => {
                return row.visitStats.maxVisits.percent.toFixed() + '%';
            },
        },
    ]);

    const date = new Date();
    model.downloadCsv(
        `visit_reports_${date.toISOString()}.csv`,
        reports
    );
}
